(function () {
  if (window.__ptvDeliveryInit) return;
  window.__ptvDeliveryInit = true;

  function init() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-pd-scroll]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    });

    document.querySelectorAll('[data-pd-hero]').forEach(function (hero) {
      if (reduced) return hero.classList.add('is-ready', 'pd-no-motion');
      hero.classList.add('pd-hero-pending');
      requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('is-ready'); }); });
    });

    if (!reduced && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.08 });
      document.querySelectorAll('[data-pd-reveal]').forEach(function (item) {
        item.classList.add('pd-reveal-pending');
        revealObserver.observe(item);
      });
    }

    document.querySelectorAll('[data-pd-process]').forEach(function (process) {
      var steps = Array.prototype.slice.call(process.querySelectorAll('[data-pd-process-step]'));
      var track = process.querySelector('.pd-process__track');
      function activate(index) {
        steps.forEach(function (step, i) { step.classList.toggle('is-active', i === index); step.classList.toggle('is-past', i < index); });
        track.style.setProperty('--pd-progress', steps.length > 1 ? index / (steps.length - 1) : 1);
      }
      if (reduced || !('IntersectionObserver' in window)) { steps.forEach(function (s) { s.classList.add('is-active'); }); track.style.setProperty('--pd-progress', 1); return; }
      activate(0);
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) activate(steps.indexOf(entry.target)); });
      }, { rootMargin: '-38% 0px -38% 0px', threshold: 0 });
      steps.forEach(function (step) { observer.observe(step); });
    });

    document.querySelectorAll('[data-pd-focus]').forEach(function (section) {
      var items = Array.prototype.slice.call(section.querySelectorAll('[data-pd-focus-item]'));
      var marker = section.querySelector('.pd-requirements__marker, .pd-services__line');
      var manualUntil = 0;
      function activate(index, manual) {
        if (!manual && Date.now() < manualUntil) return;
        if (manual) manualUntil = Date.now() + 900;
        items.forEach(function (item, i) { item.classList.toggle('is-active', i === index); });
        if (!marker || !items[index]) return;
        if (marker.classList.contains('pd-requirements__marker')) marker.style.transform = 'translateY(' + items[index].offsetTop + 'px)';
        else marker.style.transform = 'translateY(' + (index * 100) + '%)';
      }
      if (reduced || !('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('is-active'); }); return; }
      activate(0);
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) activate(items.indexOf(entry.target)); });
      }, { rootMargin: '-40% 0px -40% 0px', threshold: 0 });
      items.forEach(function (item) { observer.observe(item); });
      items.forEach(function (item, index) {
        item.addEventListener('pointerenter', function () { activate(index, true); });
        item.addEventListener('focusin', function () { activate(index, true); });
        item.addEventListener('pointerdown', function () { activate(index, true); });
      });
    });

    document.querySelectorAll('.pd-faq details').forEach(function (detail) {
      var summary = detail.querySelector('summary');
      summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      detail.addEventListener('toggle', function () { summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false'); });
    });

    document.querySelectorAll('[data-pd-form]').forEach(initForm);
  }

  function initForm(section) {
    var form = section.querySelector('form');
    var sticky = section.querySelector('.pd-sticky-cta');
    if ('IntersectionObserver' in window && sticky) {
      new IntersectionObserver(function (entries) { sticky.classList.toggle('is-hidden', entries[0].isIntersecting); }, { threshold: 0.04 }).observe(section);
    }
    if (!form || !form.querySelector('[data-pd-step]')) return;
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-pd-step]'));
    var nav = Array.prototype.slice.call(form.querySelectorAll('[data-pd-step-jump]'));
    var navLine = form.querySelector('.pd-form-progress i');
    var next = form.querySelector('[data-pd-next]');
    var back = form.querySelector('[data-pd-back]');
    var submit = form.querySelector('[data-pd-submit]');
    var mobileProgress = form.querySelector('[data-pd-mobile-progress]');
    var validation = form.querySelector('[data-pd-validation]');
    var current = 0;
    var errorCounter = 0;

    function controlValue(name) {
      var checked = form.querySelector('[data-pd-control="' + name + '"]:checked');
      if (checked) return checked.value;
      var control = form.querySelector('[data-pd-control="' + name + '"]');
      return control ? control.value : '';
    }
    function updateConditions() {
      for (var pass = 0; pass < 3; pass += 1) {
        form.querySelectorAll('[data-pd-condition]').forEach(function (block) {
          var parts = block.getAttribute('data-pd-condition').split(':');
          var parentHidden = block.parentElement && block.parentElement.closest('[data-pd-condition][hidden]');
          var show = !parentHidden && controlValue(parts[0]) === parts.slice(1).join(':');
          block.hidden = !show;
          block.querySelectorAll('input, select, textarea').forEach(function (field) {
            field.disabled = !show;
            if (!show) clearFieldError(field);
          });
        });
      }
    }
    function showStep(index, focus) {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach(function (step, i) { step.hidden = i !== current; step.classList.toggle('is-active', i === current); });
      nav.forEach(function (item, i) { item.disabled = i > current; item.setAttribute('aria-current', i === current ? 'step' : 'false'); });
      navLine.style.transform = 'translateX(' + (current * 100) + '%)';
      if (mobileProgress) mobileProgress.textContent = 'Krok ' + (current + 1) + ' z ' + steps.length;
      back.hidden = current === 0;
      next.hidden = current === steps.length - 1;
      submit.hidden = current !== steps.length - 1;
      validation.hidden = true;
      if (current === steps.length - 1) updateSummary();
      if (focus) steps[current].querySelector('h3').setAttribute('tabindex', '-1'), steps[current].querySelector('h3').focus({ preventScroll: true });
    }
    function errorWrapper(field) {
      return field.closest('.pd-field, .pd-fieldset, .pd-consent') || field.parentElement;
    }
    function clearFieldError(field) {
      if (!field || !field.matches('input, select, textarea')) return;
      var wrapper = errorWrapper(field);
      if (wrapper) {
        wrapper.classList.remove('is-error');
        var message = wrapper.querySelector('.pd-field-error');
        if (message) message.remove();
        wrapper.querySelectorAll('[aria-invalid="true"]').forEach(function (item) {
          item.removeAttribute('aria-invalid');
          var ids = (item.getAttribute('aria-describedby') || '').split(' ').filter(function (id) { return id && id.indexOf('pd-field-error-') !== 0; });
          if (ids.length) item.setAttribute('aria-describedby', ids.join(' '));
          else item.removeAttribute('aria-describedby');
        });
      }
    }
    function markFieldError(field) {
      var wrapper = errorWrapper(field);
      if (!wrapper) return;
      clearFieldError(field);
      errorCounter += 1;
      var id = 'pd-field-error-' + errorCounter;
      var message = document.createElement('span');
      message.className = 'pd-field-error';
      message.id = id;
      message.textContent = field.validity && field.validity.typeMismatch ? 'Wpisz poprawną wartość.' : 'Uzupełnij to pole.';
      wrapper.classList.add('is-error');
      wrapper.appendChild(message);
      var group = field.type === 'radio' && field.name ? Array.prototype.slice.call(form.elements[field.name] || []) : [field];
      group.forEach(function (item) {
        item.setAttribute('aria-invalid', 'true');
        var describedBy = (item.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
        if (describedBy.indexOf(id) === -1) describedBy.push(id);
        item.setAttribute('aria-describedby', describedBy.join(' '));
      });
    }
    function validateStep(index, focusInvalid) {
      updateConditions();
      var step = steps[index];
      var fields = Array.prototype.slice.call(step.querySelectorAll('input, select, textarea')).filter(function (field) { return !field.disabled && field.required; });
      fields.forEach(clearFieldError);
      var invalid = fields.find(function (field) { return !field.checkValidity(); });
      if (invalid) {
        if (current !== index) showStep(index, false);
        validation.hidden = false;
        validation.textContent = 'Uzupełnij wymagane pola.';
        markFieldError(invalid);
        if (focusInvalid) requestAnimationFrame(function () {
          invalid.focus({ preventScroll: true });
          invalid.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        });
        return false;
      }
      validation.hidden = true;
      return true;
    }
    function updateSummary() {
      var list = form.querySelector('[data-pd-summary]');
      list.innerHTML = '';
      form.querySelectorAll('[data-pd-value]').forEach(function (field) {
        if (field.disabled || (field.type === 'radio' && !field.checked) || (field.type === 'checkbox' && !field.checked)) return;
        var value = field.value.trim();
        if (!value) return;
        var row = document.createElement('div');
        var term = document.createElement('dt');
        var description = document.createElement('dd');
        term.textContent = field.getAttribute('data-pd-value');
        description.textContent = value;
        row.appendChild(term); row.appendChild(description); list.appendChild(row);
      });
    }

    form.addEventListener('input', function (event) { clearFieldError(event.target); });
    form.addEventListener('change', function (event) { clearFieldError(event.target); updateConditions(); });
    next.addEventListener('click', function () { if (validateStep(current, true)) showStep(current + 1, true); });
    back.addEventListener('click', function () { showStep(current - 1, true); });
    nav.forEach(function (item) { item.addEventListener('click', function () { var index = Number(item.getAttribute('data-pd-step-jump')); if (index <= current) showStep(index, true); }); });
    var edit = form.querySelector('[data-pd-edit]');
    if (edit) edit.addEventListener('click', function () { showStep(0, true); });
    form.addEventListener('submit', function (event) {
      updateConditions();
      for (var index = 0; index < steps.length; index += 1) {
        if (!validateStep(index, true)) {
          event.preventDefault();
          return;
        }
      }
      submit.disabled = true;
      var submitText = submit.querySelector('.btn-text');
      if (submitText) submitText.textContent = 'Wysyłanie…';
    });
    updateConditions(); showStep(0, false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
